import AnnualReportForm from "../../../model/AnnualReportForm";

const ARE_ALL_RESEARCHERS_IN_PROJECT = `Please confirm that all current researchers accessing UK Biobank data on this 
      research project are listed below. Only those who are accessing the data are required to be registered.`;
const ACTION_TO_TAKE_IF_NO = `If no, please ask any unregistered Collaborators to submit a registration as soon as 
      possible. After approval of registration, you can add them to the Collaborator list. Please remove any 
      Collaborators who are no longer accessing UK Biobank data.`

/**
 * Props for this component
 */
interface ResearchersInProjectQuestionProps {
   form: AnnualReportForm,
   isLocked: boolean,
}

/**
 * Question to confirm if all the researchers are present in the project
 *
 * Used in: {@link ApplicantAnnualReportForm|Applicant annual report}
 *
 * @param form An {@link AnnualReportForm} object with a saved report (Could be empty if it's a new report)
 * @param isLocked A boolean to indicate if the report is locked for editing or not
 */
export default function researchersInProjectQuestion({form, isLocked}: ResearchersInProjectQuestionProps) {
   return (
      <div id="researcherListCompleteQ" className="annual-report-question">
         <label id="researcherListCompleteQMainText" className="question-text">{ARE_ALL_RESEARCHERS_IN_PROJECT}</label>
         <span id="researcherListCompleteQExtraInfo" className="extra-info">{ACTION_TO_TAKE_IF_NO}</span>
         <textarea id="researcherListCompleteQInput" name="researcherListCompleteQInput" className="form-control"
                   rows={3}
                   placeholder="No researchers present in the project" disabled={true}>{form.researcherList}</textarea>
         {isLocked ? (
            <span className="boolean-answer">{form.isResearchListCompleted ? 'YES' : 'NO'}</span>
         ) : (
            //Radio Button Area
            <div id="researcherListCompleteQRadioArea" className="yes-or-no-radio">
               <input id="researcherListCompleteQRadioYesInput" className="form-check-input" type="radio"
                      name="researcherListCompleteQRadioSelection"
                      required
                      onChange={() => {
                         form.isResearchListCompleted = true;
                      }}
                      defaultChecked={(form.annualReportId && form.isResearchListCompleted != null) ? (form.isResearchListCompleted) : false}
               />
               <label id="researcherListCompleteQRadioYesText" className="form-check-label"
                      htmlFor="researcherListCompleteQRadioYesInput">
                  Yes
               </label>
               <input id="researcherListCompleteQRadioNoInput" className="form-check-input" type="radio"
                      name="researcherListCompleteQRadioSelection"
                      required
                      onChange={() => {
                         form.isResearchListCompleted = false;
                      }}
                      defaultChecked={(form.annualReportId && form.isResearchListCompleted != null) ? (!form.isResearchListCompleted) : false}
               />
               <label id="researcherListCompleteQRadioNoText" className="form-check-label"
                      htmlFor="researcherListCompleteQRadioNoInput">
                  No
               </label>
               <div id="researcherListCompleteQRadioAreaFeedback" className="invalid-feedback">
                  Please select one option.
               </div>
            </div>
         )}
      </div>
   );
}
